import { UserRolePermission } from '~/contexts/role-authentication/role-authentication.context.tsx';

const appPermissions = {
  pages: {
    reports: {
      balanceAndFutureContractValue: UserRolePermission.OwnerOrManager,
      netRevenueReport: UserRolePermission.OwnerOrManager,
      basicChurn: UserRolePermission.OwnerOrManager,
      newMembershipSales: UserRolePermission.OwnerOrManager,
    },
  },
  components: {
    monthToDateRevenueWidget: UserRolePermission.OwnerOrManager,
  },
} as const;

export { appPermissions };
